import React, { useState, useEffect } from 'react';
import Toast from './Toast';

const initialRows = [
    { module: 'Sunday Worship', media: 'Youtube', channelName: '', channelId: '' },
    { module: 'Bible Study', media: 'Youtube', channelName: '', channelId: '' },
];

export default function YoutubeSettings({ biblestudy, worship, organization }) {
    const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
    const [rows, setRows] = useState(initialRows);
    const [worshipChannelName, setworshipChannelName] = useState(worship.channelName || '');
    const [biblestudyChannelName, setbiblestudyChannelName] = useState(biblestudy.channelName || '');
    const [worshipChannelId, setworshipChannelId] = useState(worship.channelId || '');
    const [biblestudyChannelId, setbiblestudyChannelId] = useState(biblestudy.channelId || '');
    const [bid, setBId] = useState(null);
    const [wid, setwId] = useState(null);
    const API_URL = process.env.REACT_APP_API_URL || 'http://45.194.3.128:4000/api/admin/';

    const handleChange = (index, field, value) => {
        console.log(`Changing ${field} for ${rows[index].module} to ${value}`);
        if (field === 'channelName') {
            if (index === 0) {
                setworshipChannelName(value);
            } else {
                setbiblestudyChannelName(value);
            }
        } else if (field === 'channelId') {
            if (index === 0) {
                setworshipChannelId(value);
            } else {
                setbiblestudyChannelId(value);
            }
        }


    };

    const handleSave = async () => {

        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}update-youtube-settings`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                wchannel_name: worshipChannelName,
                wchannel_id: worshipChannelId,
                bchannel_name: biblestudyChannelName,
                bchannel_id: biblestudyChannelId,
                bmoduleId: bid,
                wmoduleId: wid,
                currentOrgId: organization,
            }),
        });

         const data = await response.json();

            if (!response.ok || data.success === false) {

                if (data.message === 'Invalid token') {
                    localStorage.removeItem('token');
                    window.location.href = '/login';
                    return;
                }
                    setToast({ open: true, message: `Error saving settings: ${data.message}`, severity: "error" });
            }

            setToast({ open: true, message: "Settings saved successfully!", severity: "success" });
            setTimeout(() => window.location.reload(), 1000);
       
    };

    const handleCancel = () => {
        setRows(initialRows);

        // Reset input states
        if (worship && worship.length > 0 && biblestudy && biblestudy.length > 0) {
            setworshipChannelName(worship[0].channel_name || "");
            setworshipChannelId(worship[0].channel_id || "");
            setbiblestudyChannelName(biblestudy[0].channel_name || "");
            setbiblestudyChannelId(biblestudy[0].channel_id || "");
        } else {
            setworshipChannelName("");
            setworshipChannelId("");
            setbiblestudyChannelName("");
            setbiblestudyChannelId("");
        }
    };

    useEffect(() => {
        if (biblestudy && biblestudy.length > 0 && worship && worship.length > 0) {
            const orgbibleSettings = biblestudy[0]; // first org's settings
            const orgworshipSettings = worship[0];
            setworshipChannelName(orgworshipSettings.channel_name || '');
            setworshipChannelId(orgworshipSettings.channel_id || '');
            setbiblestudyChannelName(orgbibleSettings.channel_name || '');
            setbiblestudyChannelId(orgbibleSettings.channel_id || '');
            setBId(orgbibleSettings.id || null);
            setwId(orgworshipSettings.id || null);
        }
    }, [biblestudy, worship]);
    return (
        <div style={{ border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: 12, padding: 16, background: 'rgba(255, 255, 255, 0.05)', backdropFilter: 'blur(20px)', boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)', color: '#FFFFFF' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 16 }}>
                <thead>
                    <tr>
                        <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #ddd' }}>Module</th>
                        <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #ddd' }}>Media</th>
                        <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #ddd' }}>Channel Name</th>
                        <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #ddd' }}>Channel ID</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, idx) => (
                        <tr key={row.module}>
                            <td style={{ padding: 8 }}>{row.module}</td>
                            <td style={{ padding: 8 }}>{row.media}</td>
                            <td style={{ padding: 8 }}>
                                <input
                                    type="text"
                                    value={row.module === 'Sunday Worship' ? worshipChannelName : biblestudyChannelName}
                                    onChange={e => handleChange(idx, 'channelName', e.target.value)}
                                    style={{ width: '95%', padding: 8, borderRadius: 4, border: '1px solid #ddd' }}
                                />
                            </td>
                            <td style={{ padding: 8 }}>
                                <input
                                    type="text"
                                    value={row.module === 'Sunday Worship' ? worshipChannelId : biblestudyChannelId}
                                    onChange={e => handleChange(idx, 'channelId', e.target.value)}
                                    style={{ width: '95%', padding: 8, borderRadius: 4, border: '1px solid #ddd' }}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div style={{ textAlign: 'right' }}>
                <button
                    onClick={handleSave}
                    style={{
                        background: '#21829c',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 4,
                        padding: '8px 20px',
                        marginRight: 8,
                        cursor: 'pointer'
                    }}
                >
                    Save
                </button>
                <button
                    onClick={handleCancel}
                    style={{
                        background: '#6c757d',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 4,
                        padding: '8px 20px',
                        cursor: 'pointer'
                    }}
                >
                    Cancel
                </button>
            </div>
            <Toast toast={toast} setToast={setToast} />
        </div>
    );
}